<template>
  <section class="treeNode">
    <el-tree
      :data="topicTree"
      :props="defaultProps1"
      accordion
      @node-click="handleNodeClick"
      :render-content="renderContent"
    >
    </el-tree>
  </section>
</template>

<script>
export default {
  props: {
    sublevelTree: {
      type: Object,
      default: null,
    },
  },
  watch: {
    sublevelTree: {
      handler(value, oldName) {
        this.topicTree = this.setName(value.item)
      },
    },
  },
  data() {
    return {
      topicTree: [],
      defaultProps1: {
        label: 'text',
        children: 'item',
      },
    }
  },
  created() {
    this.topicTree = this.setName(this.sublevelTree.item)
  },
  methods: {
    handleNodeClick() {},
    renderContent: function () {
      var createElement = arguments[0]
      let nodedata = arguments[1].node.data
      if (nodedata.userdata[nodedata.userdata.length - 1].content == 'plan') {
        return createElement(
          'span',
          {
            style: {
              width: '100%',
              paddingRight: '10px',
            },
          },
          [
            createElement('img', {
              attrs: {
                src: require('@/assets/images/img/pm.png'),
                title: $t('integration.plan'),
                id: `${arguments[1].node.data.id}`,
              },
              style: {
                float: 'right',
                marginLeft: '10px',
                with: '25px',
                height: '20px',
                display: 'block',
              },
              on: {
                click: this.handleRouterhisPlan,
              },
            }),
            createElement('span', arguments[1].node.label),
          ]
        )
      } else if (
        nodedata.userdata[nodedata.userdata.length - 1].content == 'map' ||
        nodedata.userdata[nodedata.userdata.length - 1].name == 'unitId'
      ) {
        if (nodedata.item > 0) {
          let arr = nodedata.item
          this.treeNodeFn(arr)
        } else {
          return createElement('span', [
            createElement('span', arguments[1].node.label),
          ])
        }
      } else {
        return createElement(
          'span',
          {
            style: {
              width: '100%',
              paddingRight: '10px',
            },
          },
          [
            createElement('img', {
              attrs: {
                src: require('@/assets/images/img/TIME.png'),
                title: 'device.history_data',
                id: `${JSON.stringify(arguments[1].node.data)}`,
              },
              style: {
                float: 'right',
                marginLeft: '10px',
                with: '25px',
                height: '20px',
                display: 'block',
              },
              on: {
                click: this.handleRouterhis,
              },
            }),
            createElement('img', {
              attrs: {
                src: require('@/assets/images/img/metiam.png'),
                title: $t('integration.real-time_data_'),
                id: `${JSON.stringify(arguments[1].node.data)}`,
              },
              style: {
                float: 'right',
                // marginLeft:'90px',
                with: '25px',
                height: '20px',
                display: 'block',
              },
              on: {
                click: this.handleRouter,
              },
              props: {
                myProp: 'myProp',
              },
            }),
            createElement('span', arguments[1].node.label),
          ]
        )
      }
    },
    treeNodeFn(arr) {
      arr.forEach((opt) => {
        if (opt.item > 0) {
          this.treeNodeFn(opt.item)
          return createElement('span', [
            createElement('span', arguments[1].node.label),
          ])
        } else {
          let arr = opt.userdata
          arr.forEach((arg) => {
            if (arg.content == 'plan') {
              return createElement(
                'span',
                {
                  style: {
                    width: '100%',
                    paddingRight: '10px',
                  },
                },
                [
                  createElement('img', {
                    attrs: {
                      src: require('@/assets/images/img/pm.png'),
                      title: $t('integration.plan'),
                      id: `${arguments[1].node.data.id}`,
                    },
                    style: {
                      float: 'right',
                      marginLeft: '10px',
                      with: '25px',
                      height: '20px',
                      display: 'block',
                    },
                    on: {
                      click: this.handleRouterhisPlan,
                    },
                  }),
                  createElement('span', arguments[1].node.label),
                ]
              )
            } else if (arg.content == 'sensor') {
              return createElement(
                'span',
                {
                  style: {
                    width: '100%',
                    paddingRight: '10px',
                  },
                },
                [
                  createElement('img', {
                    attrs: {
                      src: require('@/assets/images/img/pm.png'),
                      title: $t('integration.plan'),
                      id: `${arguments[1].node.data.id}`,
                    },
                    style: {
                      float: 'right',
                      marginLeft: '10px',
                      with: '25px',
                      height: '20px',
                      display: 'block',
                    },
                    on: {
                      click: this.handleRouterhisPlan,
                    },
                  }),
                  createElement('img', {
                    attrs: {
                      src: require('@/assets/images/img/metiam.png'),
                      title: $t('integration.real-time_data_'),
                      id: `${JSON.stringify(arguments[1].node.data)}`,
                    },
                    style: {
                      float: 'right',
                      // marginLeft:'90px',
                      with: '25px',
                      height: '20px',
                      display: 'block',
                    },
                    on: {
                      click: this.handleRouter,
                    },
                    props: {
                      myProp: 'myProp',
                    },
                  }),
                  createElement('span', arguments[1].node.label),
                ]
              )
            } else {
              return createElement('span', [
                createElement('span', arguments[1].node.label),
              ])
            }
          })
        }
      })
    },
    //平面图
    handleRouterhisPlan(e) {
      let arg = e.target.getAttribute('id')
      let {href} = this.$router.resolve({
        path: '/flatgraph',
        query: { tagId: arg },
      })
      window.open(href, 'newwindow',
        'height=700,width=1200,top=200,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no'
      )
    },
    // 实时数据的跳转
    handleRouter(e) {
      let arg = JSON.parse(e.target.getAttribute('id'))
      let obj = JSON.stringify({
        tag: arg.text,
        type: arg.type,
        sensor_id: arg.id,
        interval:arg.interval?arg.interval:''
      })
      let routeurl = this.$router.resolve({
        path: '/realtime',
       query: { param: obj },
      })
      window.open(routeurl.href, '_blank')
    },
    // 历史数据
    handleRouterhis(e) {
      let arg = JSON.parse(e.target.getAttribute('id'))
      let obj = JSON.stringify({
        tag_id: arg.text,
        type: arg.type,
        sensor_id: arg.id,
      })
      let routeurl = this.$router.resolve({
        path: '/historyData',
        query: { param: obj },
      })
      window.open(routeurl.href, '_blank')
    },
    setName(datas) {
      //遍历树  获取id数组
      for (var i in datas) {
        datas[i]['tag_id'] = datas[i].label
        if (datas[i].temp != undefined) {
          datas[i].label =
            datas[i].label +
            '(' +
            datas[i].temp +
            '℃' +
            ',' +
            datas[i].hum +
            '%' +
            ')'
        }
        if (datas[i].item) {
          this.setName(datas[i].item)
        }
      }
      return datas
    },
  },
}
</script>

<style lang='scss' scoped>
// @import '@/styles/tree.scss';
.treeNode {
  margin-top: 20px;
  height: 80%;
  ::v-deep.el-tree {
    height: 100%;
    overflow: auto;
  }
  ::v-deep.el-tree::-webkit-scrollbar {
    display: none;
  }
  ::v-deep.el-tree-node {
    background: rgba(48, 78, 114, 0.05);
    border: 1px solid rgba(56, 56, 56, 0.1);
    box-sizing: border-box;
    border-radius: 4px 4px 0px 0px;
    border-bottom: none;
    min-height: 50px;
    height: auto;
    // 一像素消去边距
    // margin-right: -1px;
    // margin-left: -1px;
    // display: flex;
    // align-items: center;
  }
  ::v-deep.el-tree-node:nth-last-child(2) {
    border-bottom: 1px solid rgba(56, 56, 56, 0.1);
  }
  ::v-deep.el-tree-node__content {
    height: 50px !important;
    // padding-left: 10px !important;
  }
}
</style>
